module.exports = __webpack_public_path__ + "img/sun-code.c751b901.jpg";